// Formatea "05:50" -> "5:50 AM" (12h con meridiano).
export const fmtTime = (hhmm) => {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  const ampm = h < 12 ? "AM" : "PM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${ampm}`;
};

// "05:50","06:50" -> "5:50 – 6:50 AM"  (si comparten meridiano lo muestra una vez).
export const fmtRange = (start, end) => {
  const s = fmtTime(start);
  if (!end) return s;
  const e = fmtTime(end);
  if (s.slice(-2) === e.slice(-2)) return `${s.slice(0, -3)} – ${e}`;
  return `${s} – ${e}`;
};

// --- Huso del estudio (Florida) ---
// Las clases se guardan en hora local del estudio. Para saber cuánto falta hay
// que preguntarle el desfase a la zona real: en noviembre pasa de -4 a -5 y una
// cuenta fija se equivocaría por una hora entera.
export const ZONA_ESTUDIO = "America/New_York";

const offsetEstudioMin = (utcMs) => {
  const p = {};
  for (const x of new Intl.DateTimeFormat("en-US", {
    timeZone: ZONA_ESTUDIO,
    hour12: false,
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  }).formatToParts(new Date(utcMs)))
    p[x.type] = x.value;
  const comoUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
  return (comoUTC - utcMs) / 60000;
};

/** Instante real (ms) de una fecha y hora escritas en hora del estudio. */
export const instanteEstudio = (date, time) => {
  const ingenuo = Date.parse(`${date}T${time}:00Z`);
  let real = ingenuo - offsetEstudioMin(ingenuo) * 60000;
  return ingenuo - offsetEstudioMin(real) * 60000;
};

/** Minutos que faltan para que empiece una clase del estudio. */
export const minutosHasta = (date, time) => (instanteEstudio(date, time) - Date.now()) / 60000;

/** "lunes 12 de octubre" / "Monday, October 12". */
export const fmtFechaLarga = (iso, lang = "es") =>
  new Date(`${iso}T12:00:00`).toLocaleDateString(lang === "en" ? "en-US" : "es-ES", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
